import { EChartsCoreOption } from 'echarts';
import {
  ChartDataResponseResult,
  ChartProps,
  DataRecordValue,
  QueryFormColumn,
  QueryFormData,
  QueryFormMetric,
  SetDataMaskHook,
} from '@superset-ui/core';
import {
  DEFAULT_LEGEND_FORM_DATA,
  EchartsLegendFormData,
} from '../../../types';

export type EchartsNegativeBarFormData = QueryFormData &
  EchartsLegendFormData & {
    groupby: QueryFormData[];
    metric: QueryFormMetric;
    showLabels: boolean;
    // numberFormat: string;
    // emitFilter: boolean;
};

export interface EchartsNegativeBarChartProps
  extends ChartProps<EchartsNegativeBarFormData> {
  formData: EchartsNegativeBarFormData;
  queriesData: ChartDataResponseResult[];
}

// @ts-ignore
export const DEFAULT_FORM_DATA: EchartsNegativeBarFormData = {
  ...DEFAULT_LEGEND_FORM_DATA,
  groupby: [],
  showLabels: true,
//   numberFormat: 'SMART_NUMBER',
//   emitFilter: false,
};

export interface NegativeBarChartTransformedProps {
  formData: EchartsNegativeBarFormData;
  height: number;
  width: number;
  echartOptions: EChartsCoreOption;
  setDataMask: SetDataMaskHook;
  labelMap: Record<string, DataRecordValue[]>;
  groupby: QueryFormColumn[];
}